
import { computed, defineComponent, inject, nextTick, ref } from 'vue';
import { useTypesStore } from '@/store';
import useUtils from '@/hooks/useUtils';
import BankExpenseForm from '@/components/forms/BankExpenseForm.vue';
import CommonExpenseForm from '@/components/forms/CommonExpenseForm.vue';
import CreditCardExpenseForm from '@/components/forms/CreditCardExpenseForm.vue';
import IncomeExpenseForm from '@/components/forms/IncomeExpenseForm.vue';
import MiscellaneousExpenseForm from '@/components/forms/MiscellaneousExpenseForm.vue';
import VehicleExpenseForm from '@/components/forms/VehicleExpenseForm.vue';
import SideBar from '@/components/partials/SideBar.vue';
import Select from '@/components/ui-elements/form/Select.vue';
import {
	ExpenseFormContext,
	ExpenseFormContextType,
} from '@/components/modals/ExpenseFormProvider';
import { TypesStateInterface } from '@/store/types';

export default defineComponent({
	components: {
		BankExpenseForm,
		CommonExpenseForm,
		CreditCardExpenseForm,
		IncomeExpenseForm,
		MiscellaneousExpenseForm,
		Select,
		SideBar,
		VehicleExpenseForm,
	},
	setup() {
		const typeStore = useTypesStore();
		const { toTitleCase } = useUtils();

		const ExpenseContext = inject<ExpenseFormContextType>(
			ExpenseFormContext,
			{} as ExpenseFormContextType
		);

		const categories = computed(() => typeStore.bills);
		const formContent = ref(null);
		const formHeight = ref(0);
		const formType = computed(() => ExpenseContext.currentType.value);
		const selectedTitle = computed(() => toTitleCase(formType.value));

		const setCategory = (category: keyof TypesStateInterface) => {
			ExpenseContext.currentType.value = category;
			nextTick(() => {
				formHeight.value = (formContent.value as any)?.offsetHeight;
			});
		};

		nextTick(() => {
			formHeight.value = (formContent.value as any)?.offsetHeight;
		});

		return {
			categories,
			editMode: ExpenseContext.editMode,
			formContent,
			formHeight,
			formType,
			hideSidebar: ExpenseContext.hideSidebar,
			selectedTitle,
			setCategory,
		};
	},
});
